export default __webpack_public_path__ + "static/media/8.0a3c0676.svg";